module.exports = __webpack_public_path__ + "static/media/wolf.e9842cd2.png";